import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core';
import { get } from 'lodash';

import ContentContainer from './ContentContainer';
import { CooperationStatus } from '../../../../constants/cooperationConstants';
import Actions from '../components/Actions';
import { formatHelper } from '../../../../helpers/formatHelper';
import { expireStyles, getDateRange } from '../util/mapping';

const styles = {
  cellWrap: {
    whiteSpace: 'normal',
    workWrap: 'break-word'
  }
};

const InProgressContent = ({ classes }) => (
  <ContentContainer
    col={8}
    status={CooperationStatus.InProgress}
    renderHeader={() => (
      <TableRow>
        <TableCell />
        <TableCell>Номер запроса</TableCell>
        <TableCell className={classes.cellWrap}>Дата запроса / Срок ответа</TableCell>
        <TableCell>Заявитель</TableCell>
        <TableCell className={classes.cellWrap}>Наименование организации владельца ТС</TableCell>
        <TableCell className={classes.cellWrap}>№ документа, присвоенный заявителем</TableCell>
        <TableCell>Сотрудник</TableCell>
        <TableCell align="right">Действие</TableCell>
      </TableRow>
    )}
    renderBody={({ items }) => {
      return items.map(item => (
        <TableRow key={item.id} hover {...expireStyles(item.smev)}>
          <TableCell />
          <TableCell className="nowrap">{`№${formatHelper.appNumber(item)}`}</TableCell>
          <TableCell>{getDateRange(item.smev)}</TableCell>
          <TableCell>{item.smev.authority_name}</TableCell>
          <TableCell>{item.username}</TableCell>
          <TableCell>{item.smev.output_number}</TableCell>
          <TableCell>{get(item, 'admin.name')}</TableCell>
          <TableCell align="right" className="nowrap">
            <Actions id={item.id} />
          </TableCell>
        </TableRow>
      ));
    }}
  />
);

export default withStyles(styles)(InProgressContent);
